<app-global-loader></app-global-loader>
<app-snackbar-notification></app-snackbar-notification>

<router-outlet />
